import VueRouter from 'vue-router';

let routes = [
    {
        path: '/',
        redirect: {
            name: 'home'
        },
        name: 'root'
    },
    
    {
        path: '/home',
        component: require('./views/home').default,
        name: 'home'
    },

    {
        path: '/timelines',
        component: require('./views/timelines/index').default,
        name: 'timelines.index'
    },

    {
        path: '/timelines/:id',
        component: require('./views/timelines/show').default,
        name: 'timelines.show'
    },

    {
        path: '/timelines/:id/present',
        component: require('./views/presentation/show').default,
        name: 'timelines.present'
    },

    {
        path: '/events/:id',
        component: require('./views/events/show').default,
        name: 'events.show'
    },

    {
        path: '/contextualization',
        component: require('./views/contextualization/show').default,
        name: 'contextualization.show'
    },
    
    {
        path: '/contextualization/present',
        component: require('./views/contextualization/present').default,
        name: 'contextualization.present'
    },
];

export default new VueRouter({
    routes,
    linkActiveClass: 'is-active',
    mode: 'history'
});